<script setup lang="ts">
import { onMounted, ref } from 'vue';
import LoggedOutFrame from '../layouts/LoggedOutFrame.vue';
import { OauthService } from '../services/oauth.service';
import { useUserStore } from '../stores/user';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { RouteNames } from '../router';

const error = ref('');
const isLoading = ref(true);

onMounted(async () => {
  const params = new URL(document.location.href.replace('/#', '')).searchParams;
  const code = params.get('code');

  const { setUserProfile } = useUserStore();
  const { t } = useI18n();
  const router = useRouter();

  if (code) {
    const oauthService = new OauthService();

    try {
      const loginModel = await oauthService.callback(code);

      setUserProfile(loginModel);

      router.replace({ name: RouteNames.Home });
    } catch (e: any) {
      error.value = t(e.message);
    }

    isLoading.value = false;
  } else {
    // should probably also show an error on this case
    router.push(RouteNames.Login);
  }
});
</script>

<template>
  <LoggedOutFrame :background-image-url="$t('login.background_image_url')" :header="$t('oauthLogin.header')">
    <div v-if="error" class="error">
      {{ error }}
    </div>
    <div v-else-if="isLoading">
      {{ $t('oauthLogin.in_progress') }}
    </div>
  </LoggedOutFrame>
</template>
